import { render } from "./MFITTCouponList.vue?vue&type=template&id=2b01acbc&scoped=true"
import script from "./MFITTCouponList.vue?vue&type=script&lang=js"
export * from "./MFITTCouponList.vue?vue&type=script&lang=js"

import "./MFITTCouponList.vue?vue&type=style&index=0&id=2b01acbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b01acbc"

export default script